import React, { useState } from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import "../../styles/StudentCorner-NSS.css";

import Img1 from "../../images/NSS-img-1.jpg";
import Img2 from "../../images/NSS-img-2.jpg";
import Img3 from "../../images/NSS-img-3.jpg";

const NSS = () => {
  const [showMore, setShowMore] = useState(false);

  const activities = [
    { icon: "🌳", title: "Tree Plantation Drive", desc: "Campus-wide tree plantation events to promote greenery." },
    { icon: "🧹", title: "Swachh Bharat Campaign", desc: "Cleanliness awareness & cleanliness drives in local villages." },
    { icon: "🩸", title: "Blood Donation Camp", desc: "Regular blood donation camps in collaboration with hospitals." },
    { icon: "📢", title: "Voter Awareness Program", desc: "Educating citizens about the importance of voting." },
    { icon: "🌊", title: "Kerala Relief Fund", desc: "Fundraising drive for Kerala flood relief efforts." },
    { icon: "🏥", title: "Health Check-up Camp", desc: "Free health camps for nearby communities." }
  ];

  const galleryImages = [Img1, Img2, Img3]; // ✅ Corrected to use imported images

  return (
    <div className="nss-page fade-in">
      <Navbar />
      <section className="nss-section">
        <h2>NSS – National Service Scheme</h2>
        <p className="nss-intro">
          NSS is our dedicated student-led unit, working with the motto <strong>“Not Me But You”</strong>,
          focusing on social responsibility, community health, environmental awareness, and nation-building.
        </p>

        <div className="nss-grid">
          {activities.slice(0, showMore ? activities.length : 4).map((act, idx) => (
            <div key={idx} className="nss-card">
              <span className="nss-icon">{act.icon}</span>
              <h3>{act.title}</h3>
              <p>{act.desc}</p>
            </div>
          ))}
        </div>

        {activities.length > 4 && (
          <button className="nss-toggle" onClick={() => setShowMore(!showMore)}>
            {showMore ? "Show Less" : "Show More"}
          </button>
        )}

        <div className="nss-gallery">
          {galleryImages.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`NSS Activity ${index + 1}`}
              className="nss-image"
            />
          ))}
        </div>

        <a href="/nss-join" className="nss-btn">Join NSS</a>
      </section>
      <Footer />
    </div>
  );
};

export default NSS;
